import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aceocean/manifest'
import pathMap from 'src/paths/pathMap'

class AceOcnManifestRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACE_OCN_MANIFEST_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_MANIFEST_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_MANIFEST_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_MANIFEST_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AceOcnManifestRoute
